import useCurrencyNumber from '@/hooks/useCurrencyNumber'

interface ProductAffiliateCashPromotionProps {
  amount?: number
  className?: string
  large?: boolean
  light?: boolean
  breakline?: boolean
  useBonus?: boolean
}
const ProductAffiliateCashPromotion = ({
  amount,
  className = '',
  large = false,
  light = false,
  breakline = false,
  useBonus,
}: ProductAffiliateCashPromotionProps) => {
  const format = useCurrencyNumber()

  if (amount === undefined || amount <= 0) return null

  return (
    <div
      className={`${large ? 'text-lg' : 'text-sm'} ${
        light ? 'text-white' : 'text-main'
      } ${useBonus ? 'line-through opacity-70' : ''} ${className}`}
    >
      Thưởng:{breakline ? <br /> : null}
      <span
        className={`ml-1 font-semibold ${
          light ? 'text-white' : 'text-priceOff'
        }`}
      >
        {format(amount)}
      </span>
    </div>
  )
}

export default ProductAffiliateCashPromotion
